import React, { useRef, useEffect, useState, MutableRefObject, FC } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import { DoubleArrowIcon } from 'common/icons/DoubleArrowIcon';
import { TextP1 } from 'uikit/Text';

import './ScrolltoFloatButton.scss';

const ScrolltoFloatButton: FC<{ offset?: number }> = ({ offset = 100 }) => {
  const anchor: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [isVisible, setVisible] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      if (anchor.current && anchor.current.getBoundingClientRect().top <= offset) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offset]);

  const handleClick = () => {
    if (anchor.current) {
      const { top } = anchor.current.getBoundingClientRect();
      scroll.scrollTo(top + window.pageYOffset - offset, { duration: 300 });
    }
  };

  return (
    <div ref={anchor}>
      {isVisible && (
        <div className="scrolltoFloatButton" role="button" onClick={handleClick}>
          <TextP1 bold className="scrolltoFloatButton__label">
            Zleć usługę bez kontaktu
          </TextP1>
          <DoubleArrowIcon className="scrolltoFloatButton__icon" />
        </div>
      )}
    </div>
  );
};

export default ScrolltoFloatButton;
